<template>
  <div class="d-flex float-left">
    <b-button
      :disabled="this.selectedIssues.length <= 0"
      id="btn_print"
      variant="info"
      class="btn btn-label btn-primary float-left"
      @click="pdfgen"
      ><i v-if="loading === false" class="bx bx-printer label-icon"></i>
      <spring-spinner
        class="label-spinner"
        v-else
        :animation-duration="3000"
        :size="20"
        color="white"
      />
      Print Issues ({{ this.selectedIssues.length }})</b-button
    >
  </div>
</template>

<script>
import { logo } from '../../../assets/images/kaliLogo.js';
import { PDFDocument } from 'pdf-lib';
import 'vue-toast-notification/dist/theme-sugar.css';
import { SpringSpinner } from 'epic-spinners';

export default {
  name: 'ReportsPDF',
  components: { SpringSpinner },
  props: {
    units: Array,
    selectedIssues: Array,
  },
  data() {
    return {
      printDocuments: false,
      loading: false,
    };
  },
  methods: {
    pdfgen: async function () {
      this.loading = true;
      var pdfMake = require('pdfmake/build/pdfmake.js');
      var pdfFonts = require('pdfmake/build/vfs_fonts.js');
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      var docDefinition = {
        content: [
          {
            table: {
              widths: ['*', 'auto'],
              body: [
                [
                  {
                    image: logo,
                    style: 'logo',
                    fit: [100, 100],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 25,
            bold: true,
            alignment: 'left',
          },
          subheader: {
            fontSize: 15,
            bold: true,
          },
          table: {
            width: '*',
          },
          logo: { alignment: 'center' },
        },
      };
      //loop the selected issues and add them to the pdf content.
      this.selectedIssues.forEach((issue) => {
        let unitString = '';
        issue.units.forEach((unit, index) => {
          if (index !== issue.units.length - 1) {
            unitString +=
              this.getUpToDateUnitName(unit) !== null ? `${this.getUpToDateUnitName(unit)}, ` : '';
          } else {
            // last one in array
            unitString +=
              this.getUpToDateUnitName(unit) !== null
                ? `${this.getUpToDateUnitName(unit)}`
                : '';
          }
        });
        docDefinition.content.push(
          { text: '\n\n' },
          {
            text: [{ text: 'Units: ', style: 'subheader' }, unitString],
          },
          { text: '\n' },
          {
            text: [
              { text: 'Reported By: ', style: 'subheader' },
              issue.submitted.name,
            ],
          },
          { text: '\n' },
          {
            text: [
              { text: 'Reported Date: ', style: 'subheader' },
              issue.submitted.time.toString().substring(0, 16),
            ],
          },
          { text: '\n' },
          {
            text: [{ text: 'Issue: ', style: 'subheader' }, issue.issue],
          },
          { text: '\n' }
        );
      });
      //after creating the pdf report from the document definition, get it in the form of a buffer array.
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getBuffer(async (buffer) => {
        //load the buffer aray into a new PDF document handled by the pdf-lib library, so we can easily append pages to the document.
        const pdfDoc = await PDFDocument.load(buffer);
        let savedPDF = await pdfDoc.save(); //get the modified pdf in a buffer array.
        //load the buffer array into a blob and open it in a new tab so the user can print or download it.
        var pdfFile = new Blob([savedPDF], {
          type: 'application/pdf',
        });
        var pdfUrl = URL.createObjectURL(pdfFile);
        window.open(pdfUrl);
        this.loading = false;
      });
    },
    getUpToDateUnitName: function (unitUid) {
      let upToDateUnitName = null;
      const unitIndex = this.units.findIndex((x) => x.UID === unitUid);
      if (unitIndex !== -1) {
        upToDateUnitName = this.units[unitIndex].name;
      }
      return upToDateUnitName;
    },
  },
};
</script>

<style scoped>
.label-spinner {
  position: absolute;
  height: 100%;
  left: 10%;
  top: 20%;
}
</style>
